/**
 * ChatBubble - Main floating chat bubble component
 * LinkedIn-style chat that appears in bottom-right corner
 */

import { useChat } from '../../contexts/ChatContext'
import ChatBubbleButton from './ChatBubbleButton'
import ChatBubbleWindow from './ChatBubbleWindow'

export default function ChatBubble() {
  const { isBubbleOpen, activeChats } = useChat()

  // Don't render if user has no active chats
  if (!activeChats || activeChats.length === 0) {
    return null
  }

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isBubbleOpen ? (
        <ChatBubbleWindow />
      ) : (
        <ChatBubbleButton />
      )}
    </div>
  )
}
